<template>
    <!-- 选项 -->
    <div class="selects">
        <div class="selects-box">
            <div class="select" @click="show = true">
                <div class="name">{{ currentName }}</div>
                <div class="arrow">
                    <van-icon name="arrow-down" :size="14" />
                </div>
            </div>
        </div>

        <van-action-sheet v-model="show">
            <van-picker :title="title" show-toolbar :columns="options" :value-key="labelName" @confirm="onConfirm" @cancel="show = false" :default-index="defaultIndex" v-if="show" />
        </van-action-sheet>
    </div>
</template>
<script>
export default {
    props: {
        value: [String, Number],
        title: String,
        options: Array,
        valueName: {
            type: String,
            default: 'value'
        },
        labelName: String
    },
    data() {
        return {
            show: false
        }
    },
    computed: {
        defaultIndex() { //选择下标
            let list = this.options || []
            for (let i = 0; i < list.length; i++) {
                if ((this.labelName ? list[i][this.valueName] : list[i]) == this.value) {
                    return i;
                }
            }
            return 0;
        },
        currentName() { //当前名称
            if (this.labelName) {
                let list = this.options || []
                for (let i = 0; i < list.length; i++) {
                    if (list[i][this.valueName] == this.value) {
                        return list[i][this.labelName];
                    }
                }
                return '请选择';
            } else {
                return this.value || '请选择'
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {

        },
        onConfirm(row) {
            this.$emit('input', row[this.valueName]);
            this.show = false;
        }
    },
    watch: {
        options: 'init',
        value: 'init'
    }
}
</script>
<style lang="scss" scoped>
.selects {
    &-box {
        display: flex;

        .select {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: 1px solid #e6e6e6;
            padding: 0 10px;
            font-size: 14px;
            height: 30px;
            border-radius: 4px;
            white-space: nowrap;
            min-width: 3em;
            margin-left: 10px;

            &:first-child {
                margin-left: 0;
            }

            .name {
                margin-right: 5px;
                max-width: 100px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>